import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_32rsz10vd0: FaireBrandEntity = {
  token: "b_32rsz10vd0",
  type: "brand",
  name: "Rainbow Unicorn Birthday Surprise",
  avatarUrl:
    "https://cdn.faire.com/fastly/d4f2e2e038702cd45ee4bdb56489b2453aff1211498e576da1b840b61ab8d1be.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4de22c32a60890016fc890c9675029eb94bbc22a1c5b973d4f5ade23fc1f474.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d4f2e2e038702cd45ee4bdb56489b2453aff1211498e576da1b840b61ab8d1be.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4de22c32a60890016fc890c9675029eb94bbc22a1c5b973d4f5ade23fc1f474.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 208,
  rating: 4.7,
  reviewCount: 193,
  isInsider: true,
  description:
    "Rainbow Unicorn Birthday Surprise is here to make your life a whole lot more fun..",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.612Z",
    importedBy: "entity-db-cli",
  },
};
